export const filterSiteCoreKeys = {
  filterPopupKey: "Common.FilterPopUp",
  saveFilterTitle: "FilterPopUp.SaveFilterTitle",
  filterName: "FilterPopUp.FilterName",
  savingFilter: "FilterPopUp.SavingFilter",
  filterSavedMessage: "FilterPopUp.FilterSavedMessage",
  filterDeletedMessage: "FilterPopUp.FilterDeletedMessage",
  deleteFilter: "FilterPopUp.DeleteFilter",
  deleteFilterActionMessage: "FilterPopUp.DeleteFilterActionMessage",
  existingFilters: "FilterPopUp.ExistingFilters",
  exceededMaxNumberOfFilters: "FilterPopUp.ExceededMaxNumberOfFilters",
  filters: "FilterPopUp.Filters",
  overwriteSuccessful: "FilterPopUp.OverwriteSuccessful",
  overwrite: "FilterPopUp.Overwrite",
  overwriteFilter: "FilterPopUp.OverwriteFilter",
  saveAsNew: "FilterPopUp.SaveAsNew",
  overwriteFilterActionMessage: "FilterPopUp.OverwriteFilterActionMessage",
  filterBeingDeletedMessage: "FilterPopUp.FilterBeingDeletedMessage",
  filtersBeingDeletedMessage: "FilterPopUp.FiltersBeingDeletedMessage",
  filterNameAlreadyExistsValidation:
    "FilterPopUp.FilterNameAlreadyExistsValidation",
  filterNameMustBeAtLeast3Characters:
    "FilterPopUp.FilterNameMustBeAtLeast3Characters",
};
